import { render, staticRenderFns } from "./Main_non.vue?vue&type=template&id=75618d44&scoped=true"
import script from "./Main_non.vue?vue&type=script&lang=js"
export * from "./Main_non.vue?vue&type=script&lang=js"
import style0 from "./Main_non.vue?vue&type=style&index=0&id=75618d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75618d44",
  null
  
)

export default component.exports